import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const MILEAGE_TRACKER_PURPOSE_REDUCER_KEY = 'mileageTrackerPurposeStore';
export type MILEAGE_TRACKER_PURPOSE_REDUCER_KEY = typeof MILEAGE_TRACKER_PURPOSE_REDUCER_KEY;

export const PersonalPurposeTypeEnum = z.enum(['CHARITY', 'MEDICAL']);

const BusinessPurposeTypeEnum = z.enum([
  'CLIENT_MEETING',
  'ERRAND',
  'PICKUP_DELIVERY',
  'RIDESHARE',
  'OTHER',
  'UNKNOWN',
]);

export const PurposeTypeEnum = z.union([PersonalPurposeTypeEnum, BusinessPurposeTypeEnum]);

export const MileageTrackerPurposeSchema = z.object({
  id: z.string().optional(),
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),

  type: PurposeTypeEnum,
  name: z.string(),
  usageType: z.string(),
  isDeleted: z.boolean().optional(),
});

export type MileageTrackerPurposeType = z.infer<typeof MileageTrackerPurposeSchema>;
export type MileageTrackerPurposeState = QcsResourceSlice<MileageTrackerPurposeType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_PURPOSE_REDUCER_KEY]: MileageTrackerPurposeState;
  }
}
